import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { NgChartsModule } from 'ng2-charts';
import { ChartData, ChartOptions } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { IDropdownSettings, NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { forkJoin } from 'rxjs';
import { Router } from '@angular/router';


interface StatisticsKpiColliDTO {
  macrozona: string;                     // NORD / CENTRO / SUD
  zona: string;                          // Nome regione
  totaleColli: number;
  colliNonCertificati: number;
  colliConsegnati: number;
  colliConProblemi: number;
  colliInTempo: number;
  colliRitardo: number;
  colliRitardoMinore2ore: number;
  colliRitardoMaggiore2Minore3ore: number;
  colliRitardoMaggiore3Minore1giorno: number;
  colliRitardoMaggiore1giorno: number;
  colliFuoriRange: number;
  percentualeColliInTempo: number;       // 0–100
}

interface Region {
  regionCode: string;
  regionName: string;
}

interface Zone {
  zoneCode: string;
  zoneName: string;
}

interface Client {
  clientCode: string;
  clientName?: string;
}

interface Brand {
  brandCode: string;
  brandName?: string;
}

interface ClientsBrands {
  clientCode: string;
  clientName?: string;
  brands: Brand[];
}

@Component({
  selector: 'app-statistics-kpi-colli',
  standalone: true,
  templateUrl: './statistics-kpi-colli.component.html',
  styleUrls: ['./statistics-kpi-colli.component.css'],
  imports: [FormsModule, CommonModule, TranslateModule, NgChartsModule, NgMultiSelectDropDownModule]
})
export class StatisticsKpiColliComponent implements OnInit {

  stats?: StatisticsKpiColliDTO[];
  loading = false;
  error = '';

  dateBefore26: boolean = false;

  // Filtri selezionati
  dateEnd: string = new Date().toISOString().split('T')[0];

  // Data inizio = 1° giorno del mese precedente
  dateStart: string = (() => {
    const today = new Date();
    // const firstDayPrevMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    // return this.formatDateLocal(firstDayPrevMonth);
    const oneWeekAgo = new Date(today);
    oneWeekAgo.setDate(today.getDate() - 7);
    return this.formatDateLocal(oneWeekAgo);
  })();

  estimatedDateEnd: string = new Date().toISOString().split('T')[0];
  estimatedDateStart: string = (() => {
    const today = new Date();
    // const firstDayPrevMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    // return this.formatDateLocal(firstDayPrevMonth);
    const oneWeekAgo = new Date(today);
    oneWeekAgo.setDate(today.getDate() - 7);
    return this.formatDateLocal(oneWeekAgo);
  })();

  type: string = '';

  selectedToggle: 'affido' | 'creazione' = 'affido';

  chartAffidatiData: ChartData<'bar' | 'line'> | undefined;
  chartConsegnatiData: ChartData<'bar' | 'line'>  | undefined;
  chartOptions: ChartOptions | undefined;   public ChartDataLabels = ChartDataLabels;   
  sortState = { active: 'macrozona', direction: 'asc' as 'asc' | 'desc' };

  zones: Zone[] = [];
  regions: Region[] = [];
  filteredRegions: Region[] = [];

  selectedZones: Zone[] = [];
  selectedRegions: Region[] = [];

  dropdownSettingsZone: IDropdownSettings = {};
  dropdownSettingsRegion: IDropdownSettings = {};

  filteredBrands: Brand[] = [];
  selectedBrands: Brand[] = [];
  filteredClients: Client[] = [];
  selectedClients: Client[] = [];
  clientsBrands: ClientsBrands[] = [];
  
  dropdownSettingsBrand: IDropdownSettings = {};
  dropdownSettingsClient: IDropdownSettings = {};

   // Sistema di paginazione (copiato da dealers-list)
   pageIndex = 0;
   pageSize = 50; // Valore di default, verrà sovrascritto nel constructor
   totalItems = 0;
   private readonly PAGE_SIZE_KEY = 'statistics-kpi-colli-size';
  constructor(private http: HttpClient, private router: Router) {
    this.pageSize = this.getStoredPageSize(); // Inizializza il pageSize nel constructor
  }

  private getStoredPageSize(): number {
    const stored = localStorage.getItem(this.PAGE_SIZE_KEY);
    return stored ? parseInt(stored, 50) : 50; // Default a 10 se non trovato
  }

  private savePageSize(size: number): void {
    localStorage.setItem(this.PAGE_SIZE_KEY, size.toString());
  }  
  
  ngOnInit(): void {
    this.sortState = { active: 'dataAffido', direction: 'desc' };
    this.confrontaDate();
    this.confrontaDateEstimated();
    
    const stored = localStorage.getItem('userFunctions');
    if(stored) {
      const parsed = JSON.parse(stored);
      this.clientsBrands = parsed.clients; 

      this.filteredClients = this.clientsBrands.map(cb => ({
        clientCode: cb.clientCode,
        clientName: cb.clientName,
      }))
      .sort((a, b) => {
        if (!a.clientName && !b.clientName) return 0;       
        if (!a.clientName) return 1;                        
        if (!b.clientName) return -1;                       
        return a.clientName.localeCompare(b.clientName);   
      });

      const allBrands: Brand[] = this.clientsBrands.flatMap(cb =>
        cb.brands.map(b => ({
          brandCode: b.brandCode,
          brandName: b.brandName,
        }))
      ).sort((a, b) => {
        if (!a.brandName && !b.brandName) return 0;       
        if (!a.brandName) return 1;                        
        if (!b.brandName) return -1;                       
        return a.brandName.localeCompare(b.brandName);   
      });

      this.filteredBrands = Array.from(
        new Map(allBrands.map(b => [b.brandCode, b])).values()
      );

      this.dropdownSettingsBrand = {
        singleSelection: false,
        idField: 'brandCode',
        textField: 'brandName',
        selectAllText: 'Seleziona tutti',
        unSelectAllText: 'Deseleziona tutti',
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: 'Cerca',
        noDataAvailablePlaceholderText: "Nessun brand trovato"
      };
      this.dropdownSettingsClient = {
        singleSelection: false,
        idField: 'clientCode',
        textField: 'clientName',
        selectAllText: 'Seleziona tutti',
        unSelectAllText: 'Deseleziona tutti',
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: 'Cerca',
        noDataAvailablePlaceholderText: "Nessun cliente trovato"
      };

      this.dropdownSettingsZone = {
        singleSelection: false,
        idField: 'zoneCode',
        textField: 'zoneName',
        selectAllText: 'Seleziona tutte',
        unSelectAllText: 'Deseleziona tutte',
        enableCheckAll: true,
        allowSearchFilter: true,
        searchPlaceholderText: 'Cerca',
        itemsShowLimit: 3,
        noDataAvailablePlaceholderText: "Nessuna macrozona trovata"
      };

      this.dropdownSettingsRegion = {
        singleSelection: false,
        idField: 'regionCode',
        textField: 'regionName',
        selectAllText: 'Seleziona tutte',
        unSelectAllText: 'Deseleziona tutte',
        enableCheckAll: true,
        allowSearchFilter: true,
        searchPlaceholderText: 'Cerca',
        itemsShowLimit: 3,
        noDataAvailablePlaceholderText: "Nessuna zona trovata"
      };

      forkJoin({
                zones: this.http.get<Zone[]>(`${environment.apiUrl}/tracking/zones`),
                regions: this.http.get<Region[]>(`${environment.apiUrl}/tracking/regions`)
            }).subscribe({
              next: (results) => {
                this.zones = results.zones;
                this.regions = results.regions;
                this.filteredRegions = results.regions;
                //this.fetchStatistics();
              },
              error: (err) => {
                console.error('Errore nel caricamento iniziale:', err);
              }
            });
  
      this.fetchStatisticsKpiColli();
    }
  }

  // loadZones(): void {
  //   this.http.get<Zone[]>(`${environment.apiUrl}/tracking/zones`)
  //     .subscribe({
  //       next: data => {
  //         this.zones = data;
  //       },
  //       error: () => {
  //         console.error('Errore caricamento macrozone');
  //       }
  //     });
  // }

  loadRegions(): void {
    this.http.get<Region[]>(`${environment.apiUrl}/tracking/regions`)
      .subscribe({
        next: data => {
          this.regions = data;
          this.filteredRegions = data;
          // pulisco le selezioni non più valide
          this.selectedRegions = this.selectedRegions?.filter(r =>
            this.filteredRegions.some(fr => fr.regionCode === r.regionCode)
          ) || [];
        },
        error: () => {
          console.error('Errore caricamento regioni');
        }
      });
  }


  onZonesChange(): void {
    // reset selezioni regione
    this.selectedRegions = [];

    // nessuna macrozona selezionata → tutte le regioni
    if (!this.selectedZones || this.selectedZones.length === 0) {
      this.filteredRegions = [...this.regions];
      return;
    }

    const requests = this.selectedZones.map(z =>
      this.http.get<Region[]>(`${environment.apiUrl}/tracking/regions-zone`, {
        params: { zoneCode: z.zoneCode }
      })
    );

    forkJoin(requests).subscribe({
      next: (results: Region[][]) => {
        // unisco e tolgo duplicati per regionCode
        const merged = results.flat();
        const uniqueMap = new Map<string, Region>();
        merged.forEach(r => {
          uniqueMap.set(r.regionCode, r);
        });

        this.filteredRegions = Array.from(uniqueMap.values());

        // pulizia eventuali selezioni precedenti (qui le abbiamo già azzerate)
        this.selectedRegions = this.selectedRegions.filter(r =>
          this.filteredRegions.some(fr => fr.regionCode === r.regionCode)
        );
      },
      error: () => {
        console.error('Errore caricamento regioni per macrozone');
      }
    });
  }

  selectAllZones(): void {
    this.selectedZones = [...this.zones];
    this.onZonesChange();
  }

  deselectAllZones(): void {
    this.selectedZones = [];
    this.onZonesChange();
  }

  selectAllRegions(): void {
    this.selectedRegions = [...this.filteredRegions];
  }

  deselectAllRegions(): void {
    this.selectedRegions = [];
  }


  onClientsChange(): void {
    this.getIntersectionClientsBrands();
  }

  getIntersectionClientsBrands() : void {
    if ((!this.selectedClients || this.selectedClients.length === 0)) {
      // Nessun client selezionato → mostro tutti i brands
      this.filteredBrands = Array.from(
        new Map(
          this.clientsBrands
            .flatMap(cb => cb.brands)
            .map(b => [b.brandCode, b])
        ).values()
      );
      //this.selectedBrands = []; // reset
      this.selectedBrands = this.selectedBrands.filter(b =>
        this.filteredBrands.some(fb => fb.brandCode === b.brandCode)
      );
      return;
    }

    // prendo i codici dei client selezionati
    const selectedCodes = this.selectedClients.map(c => c.clientCode);

    // ottengo i brands per ogni client selezionato
    const brandLists = selectedCodes.map(code => {
      const client = this.clientsBrands.find(cb => cb.clientCode === code);
      return client ? client.brands : [];
    });


    // calcolo l’intersezione tra tutte le liste
    const intersection = brandLists.reduce((acc, curr) => {
      return acc.filter(b =>
        curr.some(x => x.brandCode === b.brandCode)
      );
    });


    // aggiorno i brands disponibili
    this.filteredBrands = intersection;
    this.selectedBrands = []; // reset per evitare selezioni incoerenti
  }


  selectAllClients() {
    this.selectedClients = [...this.filteredClients];

    this.getIntersectionClientsBrands();
  }

  deselectAllClients() {
    this.selectedClients = [];

    this.getIntersectionClientsBrands();
  }

  selectAllBrands() {
    this.selectedBrands = [...this.filteredBrands];
  }

  deselectAllBrands() {
    this.selectedBrands = [];
  }

  confrontaDate(): void {
    this.dateBefore26 = false;
    
    const start = new Date(this.dateStart);
    const data = new Date(this.dateEnd);

    start.setHours(0, 0, 0, 0);
    data.setHours(0, 0, 0, 0);

    if (data <= start) {
      this.dateBefore26 = true;
    }
  }

  confrontaDateEstimated(): void {
    this.dateBefore26 = false;
    
    const start = new Date(this.estimatedDateStart);
    const data = new Date(this.estimatedDateEnd);

    start.setHours(0, 0, 0, 0);
    data.setHours(0, 0, 0, 0);

    if (data <= start) {
      this.dateBefore26 = true;
    }
  }

  getClientsBrandsSelected() : ClientsBrands[] {
    let clientsBrandsSelected: ClientsBrands[];
    if(this.filteredClients.length == 1) {
      this.selectedClients = [...this.filteredClients];
    }
    if (this.selectedClients.length > 0) {
      clientsBrandsSelected = this.selectedClients.map(sc => {
        // trovo il client originale da clientsBrands
        const originalClient = this.clientsBrands.find(cb => cb.clientCode === sc.clientCode);

        var filteredBrandsFromClient: Brand[] = [];
        if(this.selectedBrands.length > 0) {
          // brands effettivi = intersezione tra quelli del client e quelli selezionati
          filteredBrandsFromClient = (originalClient?.brands || []).filter(b =>
            this.selectedBrands.some(sb => sb.brandCode === b.brandCode)
          );
        }
        else {
          filteredBrandsFromClient = this.filteredBrands;
        }

        return {
          clientCode: sc.clientCode,
          clientName: sc.clientName,
          brands: filteredBrandsFromClient
        } as ClientsBrands;
      });
    } else if (this.selectedBrands && this.selectedBrands.length > 0) {
      // nessun client selezionato, ma brand sì
      clientsBrandsSelected = this.clientsBrands
        .map(cb => {
          const matchingBrands = cb.brands.filter(b =>
            this.selectedBrands.some(sb => sb.brandCode === b.brandCode)
          );
          if (matchingBrands.length > 0) {
            return {
              clientCode: cb.clientCode,
              clientName: cb.clientName,
              brands: matchingBrands
            } as ClientsBrands;
          }
          return null;
        })
        .filter(cb => cb !== null) as ClientsBrands[];

    } else {
      // né client né brand selezionati → ritorno tutto
      clientsBrandsSelected = this.clientsBrands;
    }


    return clientsBrandsSelected;
  }

  fetchStatisticsKpiColli(): void {
    this.loading = true;
    this.error = '';
    this.stats = undefined;

    const clientsBrandsSelected: ClientsBrands[] = this.getClientsBrandsSelected();
    const selectedZoneCodes = this.selectedZones.map(z => z.zoneCode);
    const selectedRegionCodes = this.selectedRegions.map(r => r.regionCode);

    const body = {
      clients: clientsBrandsSelected || undefined,
      dateStart: this.dateStart || undefined,
      dateEnd: this.dateEnd || undefined,
      estimatedDeliveryDateStart: this.estimatedDateStart || undefined, 
      estimatedDeliveryDateEnd: this.estimatedDateEnd || undefined,
      regionCodes: selectedRegionCodes || undefined,
      zoneCodes: selectedZoneCodes || undefined
    };

    this.http.post<StatisticsKpiColliDTO[]>(`${environment.apiUrl}/statistics/statisticsKPIColli`, body)
      .subscribe({
        next: (data) => {
          this.stats = data;
          this.applySortManualKpi();
          this.updatePagination();
          this.loading = false;
        },
        error: () => {
          this.error = 'Errore nel caricamento delle statistiche KPI colli.';
          this.loading = false;
        }
      });

    this.confrontaDate();
    this.confrontaDateEstimated();
  }

  resetFilters(): void {
    // Azzera tutti i filtri presenti, mantenendo invariate le date

    // Clienti -> ricalcola i marchi disponibili
    this.selectedClients = [];
    this.onClientsChange();

    // Marchi
    this.selectedBrands = [];

    // Macrozone -> ricalcola le zone disponibili e azzera le zone selezionate
    this.selectedZones = [];
    this.onZonesChange();

    // Zone
    this.selectedRegions = [];

    // Tipo
    this.type = '';

    this.fetchStatisticsKpiColli();
  }

  private formatDateLocal(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  exportStatisticsToExcel(): void {
    if (!this.stats || this.stats.length === 0) return;

    const exportData = this.stats.map(s => ({
      'Macrozona': s.macrozona,
      'Zona': s.zona,
      'Totale colli': +s.totaleColli,
      'Colli non cert.': +s.colliNonCertificati,
      'Colli consegnati': +s.colliConsegnati,
      'Colli con problemi': +s.colliConProblemi,
      'Colli in tempo': +s.colliInTempo,
      'Colli in ritardo': +s.colliRitardo,
      'Ritardo < 2 ore': +s.colliRitardoMinore2ore,
      'Ritardo 2-3 ore': +s.colliRitardoMaggiore2Minore3ore,
      'Ritardo 3 ore - 1 giorno': +s.colliRitardoMaggiore3Minore1giorno,
      'Ritardo > 1 giorno': +s.colliRitardoMaggiore1giorno,
      'Colli fuori range': +s.colliFuoriRange,
      '% in tempo': (+s.percentualeColliInTempo).toFixed(2) + '%'
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const blobData = new Blob([excelBuffer], { type: 'application/octet-stream' });
    const now = new Date();
    const timestamp = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now.getSeconds().toString().padStart(2, '0')}`;

    FileSaver.saveAs(blobData, `statistiche_kpi_colli_${timestamp}.xlsx`);
  }


  getPercentage(part: number, total: number): string {
  if (!total) return '-';
  return ((part / total) * 100).toFixed(2) + '%';
}

  setSort(column: string) {
    if (this.sortState.active === column) {
      this.sortState.direction = this.sortState.direction === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortState.active = column;
      this.sortState.direction = 'asc';
    }
    this.applySortManualKpi();
    this.pageIndex = 0;
    this.updatePagination();
  }

  applySortManualKpi(): void {
    if (this.stats && this.sortState.active && this.sortState.direction) {
      const isAsc = this.sortState.direction === 'asc';
      this.stats = [...this.stats].sort((a, b) => {
        switch (this.sortState.active) {
          case 'macrozona': return this.compare(a.macrozona, b.macrozona, isAsc);
          case 'zona': return this.compare(a.zona, b.zona, isAsc);
          case 'totaleColli': return this.compare(+a.totaleColli, +b.totaleColli, isAsc);
          case 'percentualeColliInTempo': return this.compare(+a.percentualeColliInTempo, +b.percentualeColliInTempo, isAsc);
          default: return 0;
        }
      });
      this.updatePagination();
    }
  }


  compare(a: string | number, b: string | number, isAsc: boolean): number {
    if (typeof a === 'string' && typeof b === 'string') {
      return a.localeCompare(b) * (isAsc ? 1 : -1);
    }
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }  
  
  updatePagination(): void {
    this.totalItems = this.stats?.length || 0;
    // Assicura che pageIndex sia valido dopo l'aggiornamento
    const totalPages = this.getNumberOfPages();
    if (this.pageIndex >= totalPages && totalPages > 0) {
      this.pageIndex = totalPages - 1;
    }
  }
  
  getNumberOfPages(): number {
    return Math.ceil(this.totalItems / Number(this.pageSize)) || 1;
  }  
  
  setPageSize(size: number): void {
    this.pageSize = Number(size);
    this.savePageSize(this.pageSize);
    this.pageIndex = 0;
    this.updatePagination();
  }
  
  getPaginatedStats(): StatisticsKpiColliDTO[] {
    if (!this.stats || this.stats.length === 0) return [];
    
    const pageSize = Number(this.pageSize); // Assicura che sia un numero
    const startIndex = this.pageIndex * pageSize;
    const endIndex = Math.min(startIndex + pageSize, this.stats.length);
    
    const result = this.stats.slice(startIndex, endIndex);
    
    // Verifica che il risultato non superi mai pageSize
    if (result.length > pageSize) {
      return result.slice(0, pageSize); // Forza il limite
    }
    
    return result;
  }
  
  firstPage(): void {
    this.pageIndex = 0;
  }

  previousPage(): void {
    if (this.pageIndex > 0) {
      this.pageIndex--;
    }
  }  
  
  nextPage(): void {
    if (this.pageIndex < this.getNumberOfPages() - 1) {
      this.pageIndex++;
    }
  }
  lastPage(): void {
    const totalPages = this.getNumberOfPages();
    this.pageIndex = Math.max(totalPages - 1, 0);
  }

    // Funzioni per navigazione date
  decrementStartDate(): void {
    if (this.dateStart) {
      const date = new Date(this.dateStart);
      date.setDate(date.getDate() - 1);
      this.dateStart = date.toISOString().split('T')[0];
    }
  }

  incrementStartDate(): void {
    if (this.dateStart) {
      const date = new Date(this.dateStart);
      date.setDate(date.getDate() + 1);
      this.dateStart = date.toISOString().split('T')[0];
    }
  }

  decrementEndDate(): void {
    if (this.dateEnd) {
      const date = new Date(this.dateEnd);
      date.setDate(date.getDate() - 1);
      this.dateEnd = date.toISOString().split('T')[0];
    }
  }

  incrementEndDate(): void {
    if (this.dateEnd) {
      const date = new Date(this.dateEnd);
      date.setDate(date.getDate() + 1);
      this.dateEnd = date.toISOString().split('T')[0];
    }
  }


  decrementStartEstimatedDate(): void {
    if (this.estimatedDateStart) {
      const date = new Date(this.estimatedDateStart);
      date.setDate(date.getDate() - 1);
      this.estimatedDateStart = date.toISOString().split('T')[0];
    }
  }

  incrementStartEstimatedDate(): void {
    if (this.estimatedDateStart) {
      const date = new Date(this.estimatedDateStart);
      date.setDate(date.getDate() + 1);
      this.estimatedDateStart = date.toISOString().split('T')[0];
    }
  }

  decrementEndEstimatedDate(): void {
    if (this.estimatedDateEnd) {
      const date = new Date(this.estimatedDateEnd);
      date.setDate(date.getDate() - 1);
      this.estimatedDateEnd = date.toISOString().split('T')[0];
    }
  }

  incrementEndEstimatedDate(): void {
    if (this.estimatedDateEnd) {
      const date = new Date(this.estimatedDateEnd);
      date.setDate(date.getDate() + 1);
      this.estimatedDateEnd = date.toISOString().split('T')[0];
    }
  }

  getBadgeClass(current: number, base: number): string {
    if (!base || base === 0) return 'bg-secondary';
    const percent = (current / base) * 100;
    if (percent >= 80) return 'underline-green';
    if (percent >= 50) return 'underline-orange';
    return 'underline-red';
  }

  onSubmit() {
    this.fetchStatisticsKpiColli();
  }

  getTotals() {
    if (!this.stats || this.stats.length === 0) {
      return {
      totaleColli: 0,
      colliNonCertificati: 0,
      colliConsegnati: 0,
      colliConProblemi: 0,
      colliInTempo: 0,
      colliRitardo: 0,
      colliRitardoMinore2ore: 0,
      colliRitardoMaggiore2Minore3ore: 0,
      colliRitardoMaggiore3Minore1giorno: 0,
      colliRitardoMaggiore1giorno: 0,
      colliFuoriRange: 0
    };
  }

    return {
      totaleColli: this.stats.reduce((a, b) => a + (b.totaleColli || 0), 0),
      colliNonCertificati: this.stats.reduce((a, b) => a + (b.colliNonCertificati || 0), 0),
      colliConsegnati: this.stats.reduce((a, b) => a + (b.colliConsegnati || 0), 0),
      colliConProblemi: this.stats.reduce((a, b) => a + (b.colliConProblemi || 0), 0),
      colliInTempo: this.stats.reduce((a, b) => a + (b.colliInTempo || 0), 0),
      colliRitardo: this.stats.reduce((a, b) => a + (b.colliRitardo || 0), 0),
      colliRitardoMinore2ore: this.stats.reduce((a, b) => a + (b.colliRitardoMinore2ore || 0), 0),
      colliRitardoMaggiore2Minore3ore: this.stats.reduce((a, b) => a + (b.colliRitardoMaggiore2Minore3ore || 0), 0),
      colliRitardoMaggiore3Minore1giorno: this.stats.reduce((a, b) => a + (b.colliRitardoMaggiore3Minore1giorno || 0), 0),
      colliRitardoMaggiore1giorno: this.stats.reduce((a, b) => a + (b.colliRitardoMaggiore1giorno || 0), 0),
      colliFuoriRange: this.stats.reduce((a, b) => a + (b.colliFuoriRange || 0), 0),
    };
  }

  openOverviewDelivered(stat: any, filter: string): void {
    const region = this.regions?.find(r => r.regionName === stat.zona);

    let queryParams: any = {};
    if(filter == 'consegnati') {
      queryParams.deliveryStatus = 'delivered';
    }
    else if(filter == 'conProblemi') {
      queryParams.withProblemsStatus = 'with_problems';
    }
    else if(filter == 'nonConsegnati') {
      queryParams.deliveryStatus = 'not_delivered';
    }
    else if(filter == 'inTempo') {
      queryParams.onTimeStatus = 'ON_TIME';
    }
    else if(filter == 'inRitardo') {
      queryParams.onTimeStatus = 'NOT_ON_TIME';
    }
    else if(filter == 'inRitardoMin2h') {
      queryParams.onTimeStatus = 'DELAY_LT_2H';
    }
    else if(filter == 'inRitardoMin2hMax3h') {
      queryParams.onTimeStatus = 'DELAY_2H_3H';
    }
    else if(filter == 'inRitardoMin3hMax1d') {
      queryParams.onTimeStatus = 'DELAY_3H_1D';
    }
    else if(filter == 'inRitardoOltre1d') {
      queryParams.onTimeStatus = 'DELAY_GT_1D';
    }
    else if(filter == 'fuoriRange') {
      queryParams.inRangeStatus = 'NOT_IN_RANGE';
    }

    if (region) {
      queryParams.regionCode = region.regionCode;
    }
    if (this.dateStart) {
      queryParams.parcelDateStart = this.dateStart;
    }
    if (this.dateEnd) {
      queryParams.parcelDateEnd = this.dateEnd;
    }
    if (this.estimatedDateStart) {
      queryParams.parcelEstimetedDateStart = this.estimatedDateStart;
    }
    if (this.estimatedDateEnd) {
      queryParams.parcelEstimetedDateEnd = this.estimatedDateEnd;
    }
    if (this.selectedClients) {
      queryParams.parcelClientCodes = this.selectedClients.map(c => c.clientCode);
    }
    if (this.selectedBrands) {
      queryParams.parcelBrandCodes = this.selectedBrands.map(c => c.brandCode);
    }

    const urlTree = this.router.createUrlTree(['/overview'], { queryParams });
    const url = this.router.serializeUrl(urlTree);
    window.open(url, '_blank');
  }

}
